import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  text: "Finally something that isn't just endless texting. We knew by day 4.",
  author: 'A., London',
  align: 'left',
  color: 'bg-gray-100 text-gray-900'
}, {
  text: "The 'soft launch' recap card is genius. Posted it to my close friends story immediately.",
  author: 'M., Manchester',
  align: 'right',
  color: 'bg-blue-600 text-white'
}, {
  text: 'Literally the only way to date in 2026 without losing your mind.',
  author: 'J., Bristol',
  align: 'left',
  color: 'bg-gray-100 text-gray-900'
}];
export function SocialProof() {
  return <section className="py-16 bg-white overflow-hidden" data-id="element-264">
      <div className="container mx-auto px-4" data-id="element-265">
        <div className="text-center mb-12" data-id="element-266">
          <h2 className="text-2xl font-bold mb-2" data-id="element-267">
            Loved by the "we're not dating but..." crowd
          </h2>
          <p className="text-muted-foreground" data-id="element-268">
            Built for low pressure, high clarity.
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-6" data-id="element-269">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`flex flex-col ${t.align === 'right' ? 'items-end' : 'items-start'}`} data-id="element-270">
              <div className={`max-w-[80%] px-6 py-4 rounded-2xl text-lg font-medium shadow-sm ${t.color} ${t.align === 'right' ? 'rounded-br-none' : 'rounded-bl-none'}`} data-id="element-271">
                {t.text}
              </div>
              <span className="text-xs text-muted-foreground mt-2 px-2" data-id="element-272">
                {t.author}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}